<template>
  <ContentWrapperControl
    no_bottom
    full_width
    class="h-screen bg-white flex flex-col items-center overflow-hidden z-poll papsi-poll pb-4"
  >
    <div
      class="bg-primary w-full flex flex-col items-center flex-shrink-0"
      style="height: 105px"
    >
      <div class="flex items-center w-full mt-4 px-3">
        <img
          src="@/assets/icons/papsi_arrow_back_alt.svg"
          alt="Back"
          class="w-5 h-5 cursor-pointer"
        />

        <div class="flex-1 flex justify-center">
          <img :src="getLogoPath()" class="w-24" />
        </div>

        <div class="w-5"></div>
      </div>

      <div class="flex justify-center mt-4">
        <div
          v-for="n in 3"
          @click="index = n"
          :key="n"
          class="w-8 h-8 flex items-center justify-center rounded-full text-white font-bold"
          :class="[
            index === n ? 'bg-secondary-dark' : '',
            n !== 3 ? 'mr-3' : '',
          ]"
          :style="index === n ? '' : 'background-color: rgba(255,255,255,0.2)'"
        >
          {{ n }}
        </div>
      </div>
    </div>
    <div
      v-if="index === 1"
      class="flex-1 w-full overflow-y-auto px-6 mt-6 max-w-md"
    >
      <div>
        <span class="font-bold text-primary text-left">{{
          this.lang("lbl_0000255")
        }}</span>
        <div class="flex flex-col mt-4">
          <FormTextControl
            class="mb-4"
            v-model="personal_info.lname"
            name="lname"
            :placeholder="lang('lbl_0000145')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="personal_info.fname"
            name="fname"
            :placeholder="lang('lbl_0000146')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="personal_info.suffix"
            name="suffix"
            :placeholder="lang('lbl_0000385')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="personal_info.mname"
            name="mname"
            :placeholder="lang('lbl_0000325')"
            required
            uppercase
          />
        </div>
      </div>
      <div class="mt-4">
        <span class="font-bold text-primary text-left">
          {{ this.lang("lbl_0000386") }}
        </span>
        <div class="flex flex-col mt-4">
          <ComboboxControl
            class="mb-4"
            name="id_type"
            :placeholder="lang('lbl_0000387')"
            :options="lookup.list_of_ids"
            v-model="id_info.id_type"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="id_info.id_number"
            name="id_number"
            :placeholder="lang('lbl_0000388')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            type="date"
            v-model="id_info.id_expiry"
            name="id_expiry"
            :placeholder="lang('lbl_0000389')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="id_info.tin"
            name="tin"
            :placeholder="lang('lbl_0000098')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            type="date"
            :birthday="true"
            v-model="id_info.date_of_birth"
            name="date_of_birth"
            :placeholder="lang('lbl_0000105')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="id_info.place_of_birth"
            name="place_of_birth"
            :placeholder="lang('lbl_0000390')"
            required
            uppercase
          />

          <ComboboxControl
            class="mb-4"
            :placeholder="lang('lbl_0000391')"
            name="nationality"
            :options="lookup.nationality"
            v-model="id_info.nationality"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="id_info.others"
            name="others"
            :placeholder="lang('lbl_0000100') + ' ' + lang('lbl_0000392')"
            required
            uppercase
          />
        </div>
      </div>
      <div class="mt-4">
        <span class="font-bold text-primary text-left">
          {{ this.lang("lbl_0000401") }}
        </span>
        <div class="flex flex-col mt-4">
          <ComboboxControl
            class="mb-4"
            name="country"
            :placeholder="lang('lbl_0000398')"
            :options="lookup.country"
            v-model="present_address.country"
            required
          />

          <ComboboxControl
            class="mb-4"
            name="province"
            :placeholder="lang('lbl_0000396')"
            :options="getProvinces"
            v-model="present_address.province"
            :loading="loading_provinces"
            :disabled="!isPresentPhilippines || loading_provinces"
          />

          <ComboboxControl
            class="mb-4"
            name="municipality"
            :placeholder="lang('lbl_0000397')"
            :options="getCities"
            v-model="present_address.municipality"
            :loading="loading_cities"
            :disabled="!present_address.province || loading_cities"
          />

          <FormTextControl
            class="mb-4"
            v-model="present_address.barangay"
            name="barangay"
            :placeholder="lang('lbl_0000395')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="present_address.street"
            name="street"
            :placeholder="lang('lbl_0000394')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="present_address.house_no"
            name="house_no"
            :placeholder="lang('lbl_0000393')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="present_address.zip_code"
            name="zip_code"
            :placeholder="lang('lbl_0000399')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="present_address.years_of_residency"
            name="years_of_residency"
            :placeholder="lang('lbl_0000400')"
            required
            uppercase
            :numeric="true"
          />
        </div>
      </div>
      <div class="mt-4">
        <div class="flex items-center justify-between">
          <span class="font-bold text-primary text-left">
            {{ this.lang("lbl_0000402") }}
          </span>

          <label
            class="flex items-center gap-2 text-sm text-gray-600 cursor-pointer"
          >
            <input
              type="checkbox"
              v-model="same_as_present"
              class="cursor-pointer mr-2"
            />
            <span>Same as above</span>
          </label>
        </div>

        <div class="flex flex-col mt-4">
          <FormTextControl
            class="mb-4"
            v-model="permanent_address.house_no"
            name="house_no"
            :placeholder="lang('lbl_0000393')"
            required
            uppercase
            :disabled="same_as_present"
          />

          <FormTextControl
            class="mb-4"
            v-model="permanent_address.street"
            name="street"
            :placeholder="lang('lbl_0000394')"
            required
            uppercase
            :disabled="same_as_present"
          />

          <FormTextControl
            class="mb-4"
            v-model="permanent_address.barangay"
            name="barangay"
            :placeholder="lang('lbl_0000395')"
            required
            uppercase
            :disabled="same_as_present"
          />

          <ComboboxControl
            class="mb-4"
            name="municipality"
            :placeholder="lang('lbl_0000397')"
            :options="getGenders"
            v-model="permanent_address.municipality"
            required
            :disabled="same_as_present"
          />

          <ComboboxControl
            class="mb-4"
            name="province"
            :placeholder="lang('lbl_0000396')"
            :options="lookup.provinces"
            v-model="permanent_address.province"
            required
            :disabled="same_as_present"
          />

          <ComboboxControl
            class="mb-4"
            name="country"
            :placeholder="lang('lbl_0000398')"
            :options="lookup.country"
            v-model="permanent_address.country"
            required
            :disabled="same_as_present"
          />

          <FormTextControl
            class="mb-4"
            v-model="permanent_address.zip_code"
            name="zip_code"
            :placeholder="lang('lbl_0000399')"
            required
            uppercase
            :disabled="same_as_present"
          />

          <FormTextControl
            class="mb-4"
            v-model="permanent_address.years_of_residency"
            name="years_of_residency"
            :placeholder="lang('lbl_0000400')"
            required
            uppercase
            :numeric="true"
            :disabled="same_as_present"
          />
        </div>
      </div>
      <div class="flex flex-row mt-4">
        <ButtonControl
          class="flex-1 mr-2"
          :outline="true"
          @click="this.$router.push('/dashboard')"
        >
          {{ this.lang("lbl_0000181") }}</ButtonControl
        >
        <ButtonControl class="flex-1 ml-2" @click="index = 2">{{
          this.lang("lbl_0000033")
        }}</ButtonControl>
      </div>
    </div>
    <div
      v-if="index === 2"
      class="flex-1 w-full overflow-y-auto px-6 mt-6 max-w-md"
    >
      <div>
        <span class="font-bold text-primary text-left">
          {{ this.lang("lbl_0000404") }}
        </span>
        <div class="flex flex-col mt-4">
          <FormTextControl
            class="mb-4"
            v-model="contact_information.telephone_number_format"
            name="telephone_number_format"
            :placeholder="lang('lbl_0000405')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="contact_information.social_media_account"
            name="social_media_account"
            :placeholder="lang('lbl_0000406')"
            required
            uppercase
          />

          <div class="flex items-end mb-4 w-full gap-2">
            <div class="flex-1 min-w-0">
              <FormTextControl
                v-model="contact_information.mobile_number"
                name="mobile_number"
                :placeholder="lang('lbl_0000007')"
                required
                uppercase
                type="mobile"
              />
            </div>

            <button
              type="button"
              class="flex-shrink-0 py-3 ml-2 rounded-lg text-sm font-bold uppercase shadow outline-none bg-success text-white"
              style="width: 85px"
            >
              {{ this.lang("lbl_0000016") }}
            </button>
          </div>

          <div class="flex items-end mb-4 w-full gap-2">
            <div class="flex-1 min-w-0">
              <FormTextControl
                v-model="contact_information.email_address"
                name="email_address"
                :placeholder="lang('lbl_0000005')"
                required
                uppercase
              />
            </div>

            <button
              type="button"
              class="flex-shrink-0 py-3 ml-2 rounded-lg text-sm font-bold uppercase shadow outline-none bg-success text-white"
              style="width: 85px"
            >
              {{ this.lang("lbl_0000016") }}
            </button>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <span class="font-bold text-primary text-left">
          {{ this.lang("lbl_0000407") }}
        </span>
        <div class="flex flex-col mt-4">
          <ComboboxControl
            class="mb-4"
            :placeholder="lang('lbl_0000408')"
            name="employment_status"
            :options="lookup.employment_status"
            v-model="employment_information.status"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="employment_information.others"
            name="others"
            :placeholder="lang('lbl_0000100') + ' ' + lang('lbl_0000392')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="employment_information.employer"
            name="employer"
            :placeholder="lang('lbl_0000409')"
            required
            uppercase
          />

          <ComboboxControl
            class="mb-4"
            :placeholder="lang('lbl_0000410')"
            name="nature_of_work"
            :options="lookup.nature_of_work"
            v-model="employment_information.nature_of_work"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="employment_information.other_work"
            name="other_work"
            :placeholder="lang('lbl_0000411')"
            required
            uppercase
          />

          <ComboboxControl
            class="mb-4"
            name="country"
            :placeholder="lang('lbl_0000398')"
            :options="getGenders"
            v-model="present_address.country"
            required
          />

          <ComboboxControl
            class="mb-4"
            name="province"
            :placeholder="lang('lbl_0000396')"
            :options="getGenders"
            v-model="present_address.province"
            required
          />

          <ComboboxControl
            class="mb-4"
            name="municipality"
            :placeholder="lang('lbl_0000397')"
            :options="getGenders"
            v-model="present_address.municipality"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="present_address.barangay"
            name="barangay"
            :placeholder="lang('lbl_0000395')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="present_address.street"
            name="street"
            :placeholder="lang('lbl_0000394')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="present_address.house_no"
            name="house_no"
            :placeholder="lang('lbl_0000393')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="present_address.zip_code"
            name="zip_code"
            :placeholder="lang('lbl_0000399')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="contact_information.email_address"
            name="email_address"
            :placeholder="lang('lbl_0000005')"
            required
            uppercase
          />
        </div>
      </div>
      <div class="flex flex-row mt-4">
        <ButtonControl class="flex-1 mr-2" :outline="true" @click="index = 1">
          {{ this.lang("lbl_0000181") }}</ButtonControl
        >
        <ButtonControl class="flex-1 ml-2" @click="index = 3">{{
          this.lang("lbl_0000033")
        }}</ButtonControl>
      </div>
    </div>
    <div
      v-if="index === 3"
      class="flex-1 w-full overflow-y-auto px-6 mt-6 max-w-md"
    >
      <div>
        <span class="font-bold text-primary text-left">
          {{ this.lang("lbl_0000412") }}
        </span>
        <div class="flex flex-col mt-4">
          <ComboboxControl
            class="mb-4"
            :placeholder="lang('lbl_0000413')"
            name="source_of_funds"
            :options="getGenders"
            v-model="source_of_funds.source"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="source_of_funds.others"
            name="others"
            :placeholder="lang('lbl_0000100') + ' ' + lang('lbl_0000392')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="source_of_funds.remitter_1.name"
            name="remitter_1_name"
            :placeholder="lang('lbl_0000415')"
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="source_of_funds.remitter_1.relationship"
            name="remitter_1_relationship"
            :placeholder="lang('lbl_0000416')"
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="source_of_funds.remitter_2.name"
            name="remitter_2_name"
            :placeholder="lang('lbl_0000417')"
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="source_of_funds.remitter_2.relationship"
            name="remitter_2_relationship"
            :placeholder="lang('lbl_0000418')"
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="source_of_funds.remitter_3.name"
            name="remitter_3_name"
            :placeholder="lang('lbl_0000419')"
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="source_of_funds.remitter_3.relationship"
            name="remitter_3_relationship"
            :placeholder="lang('lbl_0000420')"
            uppercase
          />
        </div>
      </div>
      <div class="mt-4">
        <span class="font-bold text-primary text-left">
          {{ this.lang("lbl_0000421") }}
        </span>
        <div class="flex flex-col mt-4">
          <ComboboxControl
            class="mb-4"
            :placeholder="lang('lbl_0000422')"
            name="is_person"
            :options="getGenders"
            v-model="us_fatca.is_person"
            required
          />

          <ComboboxControl
            class="mb-4"
            :placeholder="lang('lbl_0000423')"
            name="civil_status"
            :options="getGenders"
            v-model="us_fatca.civil_status"
            required
          />

          <ComboboxControl
            class="mb-4"
            :placeholder="lang('lbl_0000104')"
            name="gender"
            :options="getGenders"
            v-model="us_fatca.gender"
            required
          />

          <ComboboxControl
            class="mb-4"
            :placeholder="lang('lbl_0000424')"
            name="citizenship"
            :options="getGenders"
            v-model="us_fatca.citizenship"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="us_fatca.others"
            name="others"
            :placeholder="lang('lbl_0000100') + ' ' + lang('lbl_0000392')"
            required
            uppercase
          />
        </div>
      </div>
      <div class="mt-4">
        <span class="font-bold text-primary text-left">
          {{ this.lang("lbl_0000425") }}
        </span>
        <div class="flex flex-col mt-4">
          <FormTextControl
            class="mb-4"
            v-model="mother_maiden_name.lname"
            name="lname"
            :placeholder="lang('lbl_0000426')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="mother_maiden_name.fname"
            name="fname"
            :placeholder="lang('lbl_0000427')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="mother_maiden_name.mname"
            name="mname"
            :placeholder="lang('lbl_0000426')"
            required
            uppercase
          />
        </div>
      </div>
      <div class="mt-4">
        <span class="font-bold text-primary text-left">
          {{ this.lang("lbl_0000429") }}
        </span>
        <div class="flex flex-col mt-4">
          <FormTextControl
            class="mb-4"
            v-model="spouse_info.lname"
            name="lname"
            :placeholder="lang('lbl_0000430')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="spouse_info.fname"
            name="fname"
            :placeholder="lang('lbl_0000431')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="spouse_info.mname"
            name="mname"
            :placeholder="lang('lbl_0000432')"
            required
            uppercase
          />
          <FormTextControl
            class="mb-4"
            v-model="spouse_info.date_of_birth"
            name="date_of_birth"
            :placeholder="lang('lbl_0000433')"
            required
            uppercase
            type="date"
          />

          <FormTextControl
            class="mb-4"
            v-model="spouse_info.occupation"
            name="occupation"
            :placeholder="lang('lbl_0000434')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="spouse_info.number"
            name="number"
            :placeholder="lang('lbl_0000393')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="spouse_info.street"
            name="street"
            :placeholder="lang('lbl_0000394')"
            required
            uppercase
          />

          <ComboboxControl
            class="mb-4"
            name="country"
            :placeholder="lang('lbl_0000398')"
            :options="getGenders"
            v-model="spouse_info.country"
            required
          />

          <ComboboxControl
            class="mb-4"
            name="province"
            :placeholder="lang('lbl_0000396')"
            :options="getGenders"
            v-model="spouse_info.province"
            required
          />
          <ComboboxControl
            class="mb-4"
            name="municipality"
            :placeholder="lang('lbl_0000397')"
            :options="getGenders"
            v-model="spouse_info.municipality"
            required
          />

          <FormTextControl
            class="mb-4"
            v-model="spouse_info.barangay"
            name="barangay"
            :placeholder="lang('lbl_0000395')"
            required
            uppercase
          />

          <FormTextControl
            class="mb-4"
            v-model="spouse_info.zip_code"
            name="zip_code"
            :placeholder="lang('lbl_0000399')"
            required
            uppercase
          />
        </div>
        <div>
          <span class="font-semibold text-grey-darker">
            {{ this.lang("lbl_0000439") }}
          </span>

          <div class="flex flex-row mt-2">
            <div class="flex flex-col mr-4">
              <label class="flex flex-row items-center cursor-pointer">
                <input
                  type="checkbox"
                  v-model="products_services.credit_card"
                  class="mr-2"
                />
                <span>{{ this.lang("lbl_0000435") }}</span>
              </label>

              <label class="flex flex-row items-center cursor-pointer">
                <input
                  type="checkbox"
                  v-model="products_services.internet_banking"
                  class="mr-2"
                />
                <span>{{ this.lang("lbl_0000436") }}</span>
              </label>
            </div>

            <div class="flex flex-col">
              <label class="flex flex-row items-center cursor-pointer">
                <input
                  type="checkbox"
                  v-model="products_services.sme_loan"
                  class="mr-2"
                />
                <span>{{ this.lang("lbl_0000437") }}</span>
              </label>

              <label class="flex flex-row items-center cursor-pointer">
                <input
                  type="checkbox"
                  v-model="products_services.mobile_banking"
                  class="mr-2"
                />
                <span>{{ this.lang("lbl_0000438") }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-row mt-4">
        <ButtonControl class="flex-1 mr-2" :outline="true" @click="index = 1">
          {{ this.lang("lbl_0000181") }}</ButtonControl
        >
        <ButtonControl class="flex-1 ml-2" @click="index = 3">{{
          this.lang("lbl_0000033")
        }}</ButtonControl>
      </div>
    </div>
  </ContentWrapperControl>
</template>

<script>
import ContentWrapperControl from "@/components/controls/ContentWrapperControl.vue";
import FormTextControl from "@/components/controls/FormTextControl.vue";
import ComboboxControl from "@/components/controls/ComboboxControl.vue";
import ButtonControl from "@/components/controls/ButtonControl.vue";
import BAO from "@/services/BAO";
import mixin from "@/mixin";

export default {
  mixins: [mixin],
  emits: [
    "success",
    "error",
    "alert",
    "login",
    "logout",
    "showloader",
    "hideloader",
    "showblinder",
    "hideblinder",
    "terminate",
    "checkauth",
    "nofooter",
    "shownavbar",
    "hidenavbar",
    "opensidebar",
    "closed",
    "agreed",
  ],
  components: {
    ContentWrapperControl,
    ComboboxControl,
    FormTextControl,
    ButtonControl,
  },
  watch: {
    same_as_present(val) {
      if (val) {
        this.permanent_address = { ...this.present_address };
      }
    },
    async "present_address.province"(province_code) {
      if (!this.isPresentPhilippines || !province_code) {
        this.lookup.cities = [];
        return;
      }

      this.present_address.municipality = "";
      this.lookup.cities = [];

      this.loading_cities = true;

      try {
        const response = await BAO.getCities(province_code);

        this.lookup.cities = response.data.data.map((city) => ({
          label: city.city_name,
          value: city.fcity_code,
        }));
      } catch (error) {
        console.error("Error fetching cities:", error);
      } finally {
        this.loading_cities = false;
      }
    },
    async "present_address.municipality"(city_code) {
      if (!this.isPresentPhilippines || !city_code) {
        this.lookup.barangays = [];
        return;
      }

      this.lookup.barangays = [];

      this.loading_barangays = true;

      try {
        const response = await BAO.getBarangays(city_code);

        this.lookup.barangays = response.data.data.map((barangay) => ({
          label: barangay.brgy_name,
          value: barangay.brgy_code,
        }));
      } catch (error) {
        console.error("Error fetching barangays:", error);
      } finally {
        this.loading_barangays = false;
      }
    },
    async "present_address.country"(country) {
      this.present_address.province = "";
      this.present_address.municipality = "";
      this.present_address.barangay = "";

      this.lookup.provinces = [];
      this.lookup.cities = [];
      this.lookup.barangays = [];

      if (!country || country.toUpperCase() !== "PHILIPPINES") {
        return;
      }

      this.loading_provinces = true;

      try {
        const response = await BAO.getProvinces();

        this.lookup.provinces = response.data.data.map((province) => ({
          label: province.province_name,
          value: province.province_code,
        }));
      } catch (error) {
        console.error("Error fetching provinces:", error);
      } finally {
        this.loading_provinces = false;
      }
    },
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("hidenavbar");
    this.$emit("nofooter", true);
    this.$emit("showloader");

    BAO.getRCBCInfo()
      .then((response) => {
        const data = response.data.data;
        const mapToOption = (array) =>
          (array || []).map((value) => ({
            label: value,
            value: value,
          }));

        this.lookup.gender = mapToOption(data.gender);
        this.lookup.country = mapToOption(data.country);
        this.lookup.employment_status = mapToOption(data.employment_status);
        this.lookup.source_of_fund = mapToOption(data.source_of_fund);
        this.lookup.are_you_us = mapToOption(data.are_you_us);
        this.lookup.citizenship = mapToOption(data.citizenship);
        this.lookup.marital_status = mapToOption(data.marital_status);

        this.lookup.nationality = (data.nationality || []).map((item) => ({
          label: item.nationality,
          value: item.nationality,
          country: item.country,
        }));

        this.lookup.nature_of_work = data.nature_of_work_pnb.map(
          (nature_of_work) => ({
            label: nature_of_work.fbao_work,
            value: nature_of_work.fbank_key,
          }),
        );
        this.lookup.list_of_ids = data.list_of_ids.map((id) => ({
          label: id.bao_type,
          value: id.bao_code,
        }));

        // BAO.getProvinces()
        //   .then((response) => {
        //     this.lookup.provinces = response.data.data.map((province) => ({
        //       label: province.province_name,
        //       value: province.province_code,
        //     }));
        //   })
        //   .catch((error) => {
        //     console.error("Error fetching provinces:", error);
        //   })
        //   .finally(() => {
        //     this.$emit("hideloader");
        //   });
      })
      .catch((error) => {
        console.error("Error fetching RCBC info:", error);
      })
      .finally(() => {
        this.$emit("hideloader");
      });
  },
  data() {
    return {
      index: 1,
      loading_provinces: false,
      loading_cities: false,
      loading_barangays: false,
      lookup: {
        barangays: [],
        provinces: [],
        cities: [],
        country: [],
        nature_of_work: [],
        list_of_ids: [],
        employment_status: [],
        source_of_fund: [],
        are_you_us: [],
        citizenship: [],
        gender: [],
        marital_status: [],
      },
      personal_info: {
        fname: "",
        mname: "",
        lname: "",
        suffix: "",
      },
      id_info: {
        id_type: "",
        id_number: "",
        id_expiry: "",
        tin: "",
        date_of_birth: "",
        place_of_birth: "",
        nationality: "",
        others: "",
      },
      same_as_present: false,
      present_address: {
        house_no: "",
        street: "",
        barangay: "",
        municipality: "",
        province: "",
        country: "",
        zip_code: "",
        years_of_residency: "",
      },
      permanent_address: {
        house_no: "",
        street: "",
        barangay: "",
        municipality: "",
        province: "",
        country: "",
        zip_code: "",
        years_of_residency: "",
      },
      contact_information: {
        telephone_number_format: "",
        social_media_account: "",
        mobile_number: "",
        email_address: "",
      },
      employment_information: {
        status: "",
        others: "",
        employer: "",
        nature_of_work: "",
        other_work: "",
        number: "",
        street: "",
        barangay: "",
        province: "",
        municipality: "",
        country: "",
        zip_code: "",
        email_address: "",
      },
      source_of_funds: {
        source: "",
        others: "",
        average_monthly_amount: "",
        remitter_1: {
          name: "",
          relationship: "",
        },
        remitter_2: {
          name: "",
          relationship: "",
        },
        remitter_3: {
          name: "",
          relationship: "",
        },
      },
      us_fatca: {
        is_person: "",
        civil_status: "",
        gender: "",
        citizenship: "",
        others: "",
      },
      mother_maiden_name: {
        lname: "",
        fname: "",
        mname: "",
      },
      spouse_info: {
        lname: "",
        fname: "",
        mname: "",
        date_of_birth: "",
        occupation: "",
        number: "",
        street: "",
        barangay: "",
        province: "",
        municipality: "",
        country: "",
        zip_code: "",
      },
      products_services: {
        credit_card: false,
        internet_banking: false,
        sme_loan: false,
        mobile_banking: false,
      },
    };
  },

  computed: {
    getGenders() {
      return [
        { label: "Male", value: "M" },
        { label: "Female", value: "F" },
        { label: "Rather not say", value: "X" },
      ];
    },
    getProvinces() {
      return this.lookup.provinces || [];
    },
    getCities() {
      return this.lookup.cities || [];
    },
    isPresentPhilippines() {
      return (
        this.present_address.country &&
        this.present_address.country.toUpperCase() === "PHILIPPINES"
      );
    },
  },
  methods: {
    getLogoPath() {
      const path = "ga/";
      const file_name = "papsi_logo.png";
      if (process.env.VUE_APP_CDN_URL) {
        return process.env.VUE_APP_CDN_URL + path + file_name;
      }
    },
    submit() {
      return;
    },
  },
};
</script>

<style scoped>
.bg-white-20 {
  background-color: rgba(255, 255, 255, 0.2);
}
</style>
